import { useEffect, useRef, useState } from "react";
import { GameConfigContext, GamePlayerContext, LocalPlayerContext, PlayerSelectionContext, SceneContext } from "./context/game-context";

import { SocketState } from "./component/player-component/context/socket-state";
import { Route, Routes } from "react-router-dom";
import { SceneHandler } from "./scene-handler";
import { PlayerState } from "./component/player-component/context/player-state";
import { ListAudioNear } from "./component/html-component/list-audio-near";
import { Popup } from "./component/html-component/popup";
import { NPCPopup } from "./component/html-component/npc-popup";
import { ChangeSceneCounter } from "./component/html-component/change-scene-counter";
import { TriviaPopup } from "./component/html-component/trivia-popup";
import { ConversationSpaceUI } from "./component/html-component/conversation-space-ui";
import { Crosshair } from "./component/html-component/crosshair";
import { AmbienSound } from "./component/html-component/ambien-sound";
import { VisitorTracker } from "./component/visitor-tracker";
import { PrivateMessage } from "./private-message";
import { InstructionPopup } from "./component/html-component/instruction-popup";
import { CanvasProvider } from "./component/player-component/context/canvas-provider";
import { GameManager } from "./game-manager";
import { Fade } from "react-bootstrap";
import { PlayerDuetAnimation } from "./component/html-component/player-duet-animation";
import { BackToMainScene } from "./component/html-component/back-to-main-scene";
import { CountDown } from "./component/html-component/count-down";
import { DropItemPopup } from "./component/html-component/drop-item-popup";
import { DropNPCPopup } from "./component/html-component/dropped-npc";
import { Area } from "./component/html-component/area";
import { SocialMediaPopup } from "./component/html-component/social-media-popup";
import { ChangeServerRoom } from "./component/html-component/change-server-room";
import SettingsMenu from "./component/html-component/settings-menu";
import MenuCircular from "./component/html-component/menu-circular";
import MinimapModal from "./component/html-component/minimap-modal";
import Tutorial from "./component/html-component/tutorial";
import PlayerInteraction from "./component/html-component/player-interaction";
import PlayerEndlessrunInteraction from "./component/html-component/player-endlessrun-interaction";
import ToastNotification from "./component/html-component/toast-notification";
import LandingPage from "./component/html-component/landing-page";
import { LandscapeWarning } from "./component/html-component/landscape-warning";
import JoyStick from "./component/html-component/joystick";

function Game({ sceneID, setListAvatar, listAvatar }) {

    const getFirstPlayerName = LocalPlayerContext((state) => state.displayName);
    const getIsAccountBinded = GamePlayerContext((state) => state.isAccountBinded);
    const getIsProfileUpdated = GamePlayerContext((state) => state.isProfileUpdated);
    const setSelectPlayerCompleted = PlayerSelectionContext((state) => state.setSelectPlayerCompleted);
    const setLocalPlayerLastPosition = GamePlayerContext((state) => state.setLocalPlayerLastPosition);
    const setShowSettingMenu = GameConfigContext((state) => state.setShowSettingMenu);
    const [capturePhoto, setCapturePhoto] = useState(GamePlayerContext(state => state.capturePhoto));
    const [isOrbitOnly, setIsOrbitOnly] = useState(SceneContext(state => state.orbitOnly));
    const [isEndlesRun, setIsEndlessRun] = useState(SceneContext(state => state.isEndlesRun));
    const [animatedCamera, setAnimatedCamera] = useState(SceneContext(state => state.animatedCamera));

    const sendShoutoutChat = useRef();
    const sendSelectEmoji = useRef();
    const onChangeCameraMode = useRef();
    const toggleHoverBoard = useRef();
    const dayNightValueChanged = useRef();
    const setMonitorValue = useRef();
    const onOpenNFT = useRef();
    const onChangeScene = useRef();
    const onPlayerSit = useRef();
    const prevSelection = useRef();
    const nextSelection = useRef();
    const setAvatarSelection = useRef();
    const onRemoteClicked = useRef();
    const onRequestDuetAnimation = useRef();
    const onGetRequestDuetAnimation = useRef();
    const onReplyDuetAnimation = useRef();
    const joinHostedRoom = useRef();
    const createHostedRoom = useRef();
    const onShoutoutChat = useRef();
    const audioToggleRef = useRef();
    const controlToggle = useRef(true);
    const progress = useRef(0);
    const activeTabSettingMenu = useRef(null);
    const rtcRef = useRef(null);

    // treasure hunt modal ref
    const THAchievementModalRef = useRef();
    const THRedeemModalRef = useRef();

    const [isMobile, setIsMobile] = useState(/Android|webOS|iPhone|IPad|iPadOS|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    const isMustPortrait = useRef(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    const [lanscapeWarning, setLandscapeWarning] = useState(false);
    // const [canEnter, setCanEnter] = useState(PrivateAuthState.getCanEnter());
    const [canEnter, setCanEnter] = useState(true);
    const [playerName, setPlayerName] = useState(getFirstPlayerName);
    const [isNameInit, setIsNameInit] = useState(false);
    const [isSelectPlayer, setSelectPlayer] = useState(false);
    const [openSetting, setOpenSetting] = useState(false);
    const [openDevelopmentSetting, setOpenDevelopmentSetting] = useState(false);
    const [requiredUserData, setRequiredUserData] = useState(false);
    const isTutorialDone = localStorage.getItem('tutorialDone');
    // const [showTutorial, setShowTutorial] = useState(isTutorialDone ? false : true);
    const [showTutorial, setShowTutorial] = useState(true);

    const setLoading = GameConfigContext((state) => state.setLoading);


    const onPasswordInput = (password) => {
        if (password === 'animaverseforever') {
            setCanEnter(true);
            PrivateAuthState.setCanEnter(true);
        } else {
            alert('Wrong password!');
        }
    }

    const onSelectEmoji = (id) => {
        if (sendSelectEmoji.current !== undefined) sendSelectEmoji.current(id);
    }

    const loading = (e) => {
    }

    const onClick = (command, parameter, mesh, e) => {
        if (command === "nft") {
            onOpenNFT.current(command, parameter);
        }
        if (command === "sit") {
            onPlayerSit.current(command, parameter, mesh);
        }

        if (command == "award") {
            // showVoteModal(parameter);
        }
    }

    const onPointerEnter = (mesh, e) => {
    }

    const onPointerOut = (mesh, e) => {
    }

    const openAvatarSelection = () => {
        setSelectPlayerCompleted(false);
        setLocalPlayerLastPosition();
    }

    useEffect(() => {
        window.addEventListener("resize", handleResize)


        return () => {
            window.addEventListener("resize", handleResize)
        }
    })
    // disabled contextMenu
    document.addEventListener('contextmenu', event => event.preventDefault());

    // handling  resize window
    const handleResize = () => {
        // if (window.innerWidth <= 1024) {
        //     setIsMobile(true)
        // } else {
        //     setIsMobile(false)
        // }
    }

    const activateGuestFlow = () => {
        setIsNameInit(true);
        setPlayerName(getFirstPlayerName);
        setSelectPlayerCompleted(false);
        setSelectPlayer(true)
    }
    const activateUserLoggedInFlow = () => {
        setIsNameInit(true);
        setPlayerName(getFirstPlayerName);
        setSelectPlayerCompleted(false);
        setSelectPlayer(true)
    }

    useEffect(() => {

        const capturePhotoSubs = GamePlayerContext.subscribe(state => state.capturePhoto, (data) => {
            setCapturePhoto(data);
        });

        const isOrbitOnlySubs = SceneContext.subscribe(state => state.orbitOnly, (data) => {
            setIsOrbitOnly(data);
        });

        const isEndlesRunSubs = SceneContext.subscribe(state => state.isEndlesRun, (data) => {
            setIsEndlessRun(data);
        });

        const animatedCameraSubs = SceneContext.subscribe(state => state.animatedCamera, (data) => {
            setAnimatedCamera(data);
        });

        const checkIsNameInit = getIsAccountBinded ? true : false;
        // const checkIsNameInit = getIsProfileUpdated ? true : false;
        const playerName = LocalPlayerContext.subscribe(state => state.displayName, (data) => {
            if (data) {
                setIsNameInit(true);
                setPlayerName(data);
            }
        });

        const playerLoggedIn = GamePlayerContext.subscribe(state => state.isProfileUpdated, (data) => {
            if (data) {
                setSelectPlayerCompleted(data);
                setSelectPlayer(!data)
            }
        });

        // const playAsGuest = GamePlayerContext.subscribe(state => state.isPlayAsGuest, (data) => {
        //     if (data) {
        //         setIsNameInit(true);
        //     }
        // });


        if (checkIsNameInit && !isNameInit) {
            setIsNameInit(true);
            setPlayerName(getFirstPlayerName);
            setSelectPlayerCompleted(true);
            setSelectPlayer(false)
        } else {
            setSelectPlayer(true)
            setSelectPlayerCompleted(false);
            // setLoading(false);
        }

        const selectPlayerSub = PlayerSelectionContext.subscribe(state => state.selectPlayerCompleted, (data) => {
            setSelectPlayer(!data);
        });

        const settingsMenuShow = GameConfigContext.subscribe(state => state.showSettingMenu, (data) => {


            // if (data[1]) {
            //     activeTabSettingMenu.current = data[1];
            // }
            setOpenSetting(data);

        });


        const settingsMenuTabActive = GameConfigContext.subscribe(state => state.activeTab, (data) => {
            if (data) {
                activeTabSettingMenu.current = data;
            }

        });

        if (!canEnter) setLoading(false, null)

        return () => {
            animatedCameraSubs();
            isOrbitOnlySubs();
            selectPlayerSub();
            playerName();
            playerLoggedIn();
            // playAsGuest();
            settingsMenuShow();
            settingsMenuTabActive();
            capturePhotoSubs();
            isEndlesRunSubs();
        }
    }, [])

    useEffect(() => {
        if (isSelectPlayer) {
            setOpenSetting(true);
        }
    }, [isSelectPlayer])

    const playerModelRef = useRef();
    const onClicked = useRef();
    const onFBXUpdated = useRef();

    return (<>
        <SocketState sceneID={sceneID} setRequiredUserData={setRequiredUserData}>
            <Routes>

                <Route path="/" element={<>

                    {isNameInit && !isSelectPlayer && !requiredUserData && !isOrbitOnly && !isEndlesRun && !animatedCamera && <PlayerInteraction
                        // controlToggle={controlToggle}
                        sendShoutoutChat={sendShoutoutChat}
                        onShoutoutChat={onShoutoutChat}
                        onSelectEmoji={onSelectEmoji}
                        toggleHoverBoard={toggleHoverBoard}
                    />}
                </>
                } />

                <Route path="/:sceneid" element={<>

                    {isNameInit && !isSelectPlayer && !requiredUserData && !isOrbitOnly && !isEndlesRun && !animatedCamera && <PlayerInteraction
                        // controlToggle={controlToggle}
                        sendShoutoutChat={sendShoutoutChat}
                        onShoutoutChat={onShoutoutChat}
                        onSelectEmoji={onSelectEmoji}
                        toggleHoverBoard={toggleHoverBoard}
                    />}
                </>
                } />
                <Route path="/endlessrun" element={<>
                    <SceneHandler sceneID={sceneID} setListAvatar={setListAvatar} />
                    {isNameInit && !isSelectPlayer && <PlayerEndlessrunInteraction />}
                </>
                } />
            </Routes>
            <div id="css3d"></div>
            <div id="webgl"></div>
            <PlayerState listAvatar={listAvatar} sceneID={sceneID}>
                {!requiredUserData && isNameInit &&
                    <CanvasProvider
                        dayNightValueChanged={dayNightValueChanged}
                        isMobile={isMobile}
                    >
                        <GameManager
                            playerName={playerName}
                            //TODO
                            //Callback nya kayaknya salah ya, mungkin ada cara yang lebih estetik?
                            onSendShoutout={sendShoutoutChat}
                            onSelectEmoji={sendSelectEmoji}
                            controlToggle={controlToggle}
                            onChangeCameraMode={onChangeCameraMode}
                            setHoverBoard={toggleHoverBoard}
                            setMonitorValue={setMonitorValue}
                            onChangeScene={onChangeScene}
                            onClick={onClick}
                            onPointerEnter={onPointerEnter}
                            onPointerOut={onPointerOut}
                            audioToggle={audioToggleRef}
                            onPlayerSit={onPlayerSit}
                            onRemoteClicked={onRemoteClicked}
                            onGetRequestDuetAnimation={onGetRequestDuetAnimation}
                            prevSelection={prevSelection}
                            nextSelection={nextSelection}
                            setAvatarSelection={setAvatarSelection}
                            isSelectPlayer={isSelectPlayer}
                            onRequestDuetAnimation={onRequestDuetAnimation}
                            onReplyDuetAnimation={onReplyDuetAnimation}
                            joinHostedRoom={joinHostedRoom}
                            createHostedRoom={createHostedRoom}
                            sceneID={sceneID}
                            onShoutoutChat={onShoutoutChat}
                            showTutorial={showTutorial}
                            rtcRef={rtcRef}
                        />
                    </CanvasProvider>


                }

                {
                    !requiredUserData && isNameInit &&
                    <Fade in={openSetting}>
                        <div id='settings-menu-cover' style={{ display: !openSetting ? "none" : "block" }}>
                            <SettingsMenu
                                rtcRef={rtcRef}
                                listAvatar={listAvatar}
                                activeTab={activeTabSettingMenu}
                                openSetting={openSetting}
                                onClose={() => {
                                    setSelectPlayerCompleted(true);
                                    setShowSettingMenu(false, null);
                                    setOpenSetting(false)
                                }} />
                        </div>

                    </Fade>
                }

                {isNameInit && !isSelectPlayer && !requiredUserData && !capturePhoto && <MenuCircular
                    toggleHoverBoard={toggleHoverBoard}
                    onChangeScene={onChangeScene}
                    sceneID={sceneID}
                    setOpenDevelopmentSetting={setOpenDevelopmentSetting}
                    setShowTutorial={setShowTutorial}
                    THAchievementModalRef={THAchievementModalRef}
                    THRedeemModalRef={THRedeemModalRef}
                />
                }
                {/* <MiniMap /> */}
                <ListAudioNear rtcRef={rtcRef} />
                {/* <Participant rtcRef={rtcRef}  /> */}
            </PlayerState>
            {!requiredUserData && canEnter && !isNameInit && <LandingPage sceneID={sceneID} setLoading={setLoading} activateGuestFlow={activateGuestFlow} activateUserLoggedInFlow={activateUserLoggedInFlow} />}
            {canEnter && requiredUserData && <RequiredUserDataModal
                setRequiredUserData={setRequiredUserData}
                requiredUserData={requiredUserData} />}

            {isNameInit && !isSelectPlayer && !capturePhoto && <MinimapModal />}
            {isNameInit && !isSelectPlayer && !openSetting && !requiredUserData && <Tutorial isMobile={isMobile} showTutorial={showTutorial} setShowTutorial={setShowTutorial} sceneID={sceneID} />}

        </SocketState>
        {/* </Suspense> */}
        {/* <div className={`loading ${canEnter && isNameInit && !isLoadedAll ? "" : "hide"}`}>{isLoadedAll ? "ALL DONE!" : "LOADING ANIMAVERSE"}</div> */}

        {!canEnter && <div className="input-password"><InputPassword onPasswordInput={onPasswordInput} /></div>}


        {/* {
                    isNameInit && !isSelectPlayer && <input ref={shoutoutChatInput} type="text" id="shoutout-input" autoComplete="off" maxLength="30" onKeyPress={e => onInputKeyPress(e)} onFocus={() => enableControlToggle(false)} onBlur={() => enableControlToggle(true)} />
                }
                {
                    isNameInit && !isSelectPlayer && <button onClick={sendShoutout} id="shoutout-button">SEND</button>
                } */}
        {/* {
                    isNameInit && !isSelectPlayer && <EmojiAnimation onSelectEmoji={onSelectEmoji} />
                } */}

        {
            isNameInit && !isSelectPlayer && openDevelopmentSetting &&
            <DevelopmentTools
                onChangeCameraMode={onChangeCameraMode}
                toggleHoverBoard={toggleHoverBoard}
                dayNightValueChanged={dayNightValueChanged}
                setMonitorValue={setMonitorValue}
                onChangeScene={onChangeScene}
                sceneID={sceneID}
                audioToggleRef={audioToggleRef}
                joinHostedRoom={joinHostedRoom}
                createHostedRoom={createHostedRoom}
                openAvatarSelection={openAvatarSelection}
            />
        }
        {
            isNameInit && !isSelectPlayer &&
            <PlayerDuetAnimation
                onRemoteClicked={onRemoteClicked}
                onRequestDuetAnimation={onRequestDuetAnimation}
                onGetRequestDuetAnimation={onGetRequestDuetAnimation}
                onReplyDuetAnimation={onReplyDuetAnimation}
            />
        }
        {/* <NFTPopup onOpenNFT={onOpenNFT} /> */}
        {isNameInit && !isSelectPlayer && isMobile && !openSetting && <JoyStick />}
        <Popup />
        <NPCPopup />
        <ChangeSceneCounter />
        <TriviaPopup />
        <ConversationSpaceUI />
        <div className="audio-list" style={{ display: 'none' }}></div>

        {/* <ShareScreen rtcRef={rtcRef}/> */}
        {/* {isNameInit && !isSelectPlayer && <LoginButton />} */}
        {
            // isNameInit && !isSelectPlayer && <PlayerPoint />
        }
        {/* {isNameInit && !isSelectPlayer && <MiniProfile />} */}
        {/* {isNameInit && !isSelectPlayer && <ProfileCircular />} */}

        <ToastNotification />
        {/* <Idle /> */}
        <Crosshair />
        {
            isNameInit && !isSelectPlayer && <BackToMainScene></BackToMainScene>
        }
        {isNameInit && !isSelectPlayer && capturePhoto && <CapturePhoto />}
        {isNameInit && !isSelectPlayer && !openSetting && <CountDown showTutorial={showTutorial} />}
        {isNameInit && !isSelectPlayer && !openSetting && !isEndlesRun && <DropItemPopup />}
        {isNameInit && !isSelectPlayer && !openSetting && !isEndlesRun && <DropNPCPopup />}
        {isNameInit && !isSelectPlayer && !openSetting && <Area />}
        {isNameInit && !isSelectPlayer && !openSetting && <SocialMediaPopup />}
        {isNameInit && !isSelectPlayer && !openSetting && animatedCamera && <RhythmGameIframe />}

        {isNameInit && !isSelectPlayer && !openSetting && <ChangeServerRoom />}
        <AmbienSound />
        <VisitorTracker sceneID={sceneID} />
        <PrivateMessage />
        {isMustPortrait.current && isSelectPlayer && <LandscapeWarning />}
        <InstructionPopup showTutorial={showTutorial} />
        {isEndlesRun && <EndlesRunButton />}

        {/* <HardwareDevicesSetting rtcRef={rtcRef} /> */}
    </>
    )
}
export default Game;